import React from 'react'
import AllBlocks from '../components/AllBlocks/AllBlocks'
import TitleAndMetaTags from '../components/TitleAndMetaTags/TitleAndMetaTags'


export default function ForSellers() {
	return (
		<>
			<TitleAndMetaTags />
			<AllBlocks />
		</>
	)
}
